export default __webpack_public_path__ + "static/media/desktop-background-img-min.bb3a3ed8.png";